// Analytic Need to update

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import StatsGrid from './components/StatsGrid';
import OverviewCharts from './components/OverviewCharts';
import AnalyticsSection from './components/AnalyticsSection';
import FiltersSection from './components/FiltersSection';
import RecentSection from './components/RecentSection';
import Loading from './components/Loading';
import './Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState({});
  const [analytics, setAnalytics] = useState([]);
  const [sources, setSources] = useState([]);
  const [domains, setDomains] = useState([]);
  const [recentApplications, setRecentApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [filteredData, setFilteredData] = useState({});
  const [filterPage, setFilterPage] = useState(1);

  const [assignedCount, setAssignedCount] = useState(0);
  const [checkingAssigned, setCheckingAssigned] = useState(false);


  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
    const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const statsRes = await axios.get(`${base}/api/applicants/dashboard/stats`, { withCredentials: true });
  const analyticsRes = await axios.get(`${base}/api/applicants/dashboard/analytics`, { withCredentials: true });
  const sourcesRes = await axios.get(`${base}/api/applicants/dashboard/sources`, { withCredentials: true });
  const domainsRes = await axios.get(`${base}/api/applicants/dashboard/domains`, { withCredentials: true }); // not Working Undefine
  const recentRes = await axios.get(`${base}/api/applicants/dashboard/recent-applications`, { withCredentials: true });

      setStats(statsRes.data);
      setAnalytics(analyticsRes.data);
      setSources(sourcesRes.data);
      setDomains(domainsRes.data);
      setRecentApplications(recentRes.data);
    } catch (err) {
      console.error('Dashboard API error:', err);
    }
    setLoading(false);
  };

  const fetchAssignedCount = async () => {
  setCheckingAssigned(true);
  try {
    const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
    const res = await axios.get(`${base}/api/dashboard/assigned-count`, { withCredentials: true });

    if (res.data?.totalAssigned !== undefined) {
      setAssignedCount(res.data.totalAssigned);
      setStats(prev => ({ ...prev, assigned_project: res.data.totalAssigned }));
      alert(`✅ Total assigned applicants: ${res.data.totalAssigned}`);
    } else {
      alert('⚠️ Could not fetch assigned count');
    }
  } catch (err) {
    console.error('Error fetching assigned count:', err);
    alert('❌ Error fetching assigned count');
  }
  setCheckingAssigned(false);
};


  const handleFilterChange = async (filter, page = 1) => {
    setSelectedFilter(filter);
    setFilterPage(page);
    setLoading(true);
    let params = { page };
    // Map filter to backend query params
    switch (filter) {
      case 'applied_new':
        params = { ...params, applied_new: true };
        break;
      case 'registered':
        params = { ...params, register: true };
        break;
      case 'attended':
        params = { ...params, attended: true };
        break;
      case 'rejected':
        params = { ...params, rejected: true };
        break;
      case 'left':
        params = { ...params, left: true };
        break;
      case 'registered_startupworld':
        params = { ...params, register: true };
        break;
      case 'assigned':
        params = { ...params, assigned: true };
        break;
      default:
        params = { page };
    }
    try {
      const query = Object.entries(params).map(([k, v]) => `${k}=${v}`).join('&');
    const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const res = await axios.get(`${base}/api/applicants/filtered${query ? '?' + query : ''}`, { withCredentials: true });
      setFilteredData(res.data);
    } catch (err) {
      console.error('Filter API error:', err);
    }
    setLoading(false);
  };

  if (loading) return <Loading />;

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>ATS Dashboard</h1>
        <div className="header-actions">
          <button className="refresh-btn" onClick={fetchDashboardData}>Refresh</button>
          <button
            className="refresh-btn"
            onClick={fetchAssignedCount}
            disabled={checkingAssigned}
          >
            {checkingAssigned ? "Checking..." : "Update Assigned Count"}
          </button>

          <span className="date-display">{new Date().toLocaleDateString()}</span>
        </div>
      </div>
      <StatsGrid stats={{ ...stats, assignedApplicants: assignedCount }} />

      <div className="dashboard-tabs">
        <button className={`tab-btn${activeTab === 'overview' ? ' active' : ''}`} onClick={() => setActiveTab('overview')}>Overview</button>
        <button className={`tab-btn${activeTab === 'analytics' ? ' active' : ''}`} onClick={() => setActiveTab('analytics')}>Analytics</button>
        <button className={`tab-btn${activeTab === 'filters' ? ' active' : ''}`} onClick={() => setActiveTab('filters')}>Filters</button>
        <button className={`tab-btn${activeTab === 'recent' ? ' active' : ''}`} onClick={() => setActiveTab('recent')}>Recent</button>
      </div>
      <div className="tab-content">
        {activeTab === 'overview' && <OverviewCharts sources={sources} domains={domains} />}
        {activeTab === 'analytics' && <AnalyticsSection analytics={analytics} />}
        {activeTab === 'filters' && (
          <FiltersSection
            selectedFilter={selectedFilter}
            handleFilterChange={handleFilterChange}
            filteredData={filteredData}
            filterPage={filterPage}
            setFilterPage={setFilterPage}
          />
        )}
        {activeTab === 'recent' && <RecentSection recentApplications={recentApplications} />}
      </div>
    </div>
  );
};

export default Dashboard;